export default __webpack_public_path__ + "static/media/crashlytics.2f17b51b.svg";